export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9383.5064dd9f.jpg";